module.exports = __webpack_public_path__ + "img/progress-icon.8bc29aaa.png";